const LABELS = {
  es: {
    subtitle: 'Plan Nutricional Personalizado · Paola Michelle (Nutricionista Clínica)',
    patient: 'Paciente',
    date: 'Fecha de emisión',
    dailyTargets: 'Objetivos Nutricionales Diarios',
    calories: 'Energía',
    protein: 'Proteínas',
    carbs: 'Carbohidratos',
    fat: 'Grasas Saludables',
    fiber: 'Fibra',
    guidelines: 'Pautas Generales y Recomendaciones Clínicas',
    alternatives: 'Equivalencia / Opción B',
    groceryList: 'Lista de la Compra Semanal (Agrupada por Categoría)',
    footer:
      'TODOenBALANCE · Paola Michelle · paola@todoenbalance.com · Este plan nutricional es personalizado.',
    slots: {
      breakfast: 'Desayuno',
      mid_morning: 'Media Mañana',
      lunch: 'Comida / Almuerzo',
      snack: 'Merienda',
      dinner: 'Cena',
      workout: 'Pre / Post Entrenamiento',
    },
  },
  en: {
    subtitle: 'Personalized Clinical Nutrition Plan · Paola Michelle, MSc',
    patient: 'Patient',
    date: 'Issued on',
    dailyTargets: 'Daily Nutritional Targets',
    calories: 'Calories',
    protein: 'Protein',
    carbs: 'Carbohydrates',
    fat: 'Healthy Fats',
    fiber: 'Dietary Fiber',
    guidelines: 'General Guidelines & Clinical Recommendations',
    alternatives: 'Swap / Alternative',
    groceryList: 'Weekly Grocery Shopping List (By Category)',
    footer:
      'TODOenBALANCE · Paola Michelle · paola@todoenbalance.com · Personalized nutrition plan.',
    slots: {
      breakfast: 'Breakfast',
      mid_morning: 'Mid-Morning Snack',
      lunch: 'Lunch',
      snack: 'Afternoon Snack',
      dinner: 'Dinner',
      workout: 'Pre / Post Workout',
    },
  },
  it: {
    subtitle: 'Piano Nutrizionale Personalizzato · Dott.ssa Paola Michelle',
    patient: 'Paziente',
    date: 'Data di emissione',
    dailyTargets: 'Obiettivi Nutrizionali Giornalieri',
    calories: 'Energia',
    protein: 'Proteine',
    carbs: 'Carboidrati',
    fat: 'Grassi Sani',
    fiber: 'Fibre',
    guidelines: 'Linee Guida Generali e Raccomandazioni Cliniche',
    alternatives: 'Alternativa / Sostituzione',
    groceryList: 'Lista della Spesa Settimanale (Per Categoria)',
    footer:
      'TODOenBALANCE · Paola Michelle · paola@todoenbalance.com · Piano nutrizionale personalizzato.',
    slots: {
      breakfast: 'Colazione',
      mid_morning: 'Spuntino di Metà Mattina',
      lunch: 'Pranzo',
      snack: 'Merenda Pomeridiana',
      dinner: 'Cena',
      workout: 'Pre / Post Allenamento',
    },
  },
};

const escapeHtml = (str) =>
  String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export const exportMealPlanToPdf = (plan, patient = null) => {
  const lang = (plan.language || patient?.preferred_language || 'es').toLowerCase();
  const dict = LABELS[lang] || LABELS.es;
  const macros = plan.target_macros || {};

  // Aggregate shopping list across all days (if 1 base day, multiply by 7 for weekly shopping list)
  const days = plan.days || [];
  const multiplier = days.length === 1 ? 7 : 1;
  const groceryByCategory = {};

  days.forEach((day) => {
    (day.meals || []).forEach((meal) => {
      (meal.items || []).forEach((item) => {
        const cat = item.category || 'Other';
        if (!groceryByCategory[cat]) groceryByCategory[cat] = {};
        const key = item.name || 'Item';
        if (!groceryByCategory[cat][key]) {
          groceryByCategory[cat][key] = 0;
        }
        groceryByCategory[cat][key] += (Number(item.grams) || 0) * multiplier;
      });
    });
  });

  const daysHtml = days
    .map((day) => {
      const dayTotals = (day.meals || []).reduce(
        (acc, m) => {
          (m.items || []).forEach((it) => {
            acc.kcal += Number(it.kcal) || 0;
            acc.p += Number(it.protein_g) || 0;
            acc.c += Number(it.carbs_g) || 0;
            acc.f += Number(it.fat_g) || 0;
          });
          return acc;
        },
        { kcal: 0, p: 0, c: 0, f: 0 }
      );

      const mealsHtml = (day.meals || [])
        .map((meal) => {
          const slotLabel = dict.slots[meal.slot] || meal.slot || 'Meal';
          const itemsRows = (meal.items || [])
            .map(
              (item) => `
              <tr>
                <td style="padding: 8px 10px; border-bottom: 1px solid #f1f5f9;">
                  <strong>${escapeHtml(item.name)}</strong>
                  ${
                    item.alternatives
                      ? `<div style="font-size: 11px; color: #059669; margin-top: 2px;">↻ ${escapeHtml(
                          dict.alternatives
                        )}: ${escapeHtml(item.alternatives)}</div>`
                      : ''
                  }
                </td>
                <td style="padding: 8px 10px; border-bottom: 1px solid #f1f5f9; color: #334155;">
                  ${escapeHtml(item.portion_label || `${item.grams}g`)}
                </td>
                <td style="padding: 8px 10px; border-bottom: 1px solid #f1f5f9; text-align: right; font-size: 11px; color: #64748b;">
                  ${Math.round(item.kcal || 0)} kcal · P:${Math.round(item.protein_g || 0)}g · C:${Math.round(
                item.carbs_g || 0
              )}g · F:${Math.round(item.fat_g || 0)}g
                </td>
              </tr>`
            )
            .join('');

          return `
            <div style="margin-bottom: 16px; border: 1px solid #e2e8f0; border-radius: 12px; overflow: hidden;">
              <div style="background: #f8fafc; padding: 8px 14px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e2e8f0;">
                <span style="font-weight: 700; color: #0f172a; font-size: 13px;">
                  ${escapeHtml(slotLabel)} ${meal.time ? `· <span style="color:#0284c7">${escapeHtml(meal.time)}</span>` : ''}
                </span>
                ${
                  meal.notes
                    ? `<span style="font-size: 11px; color: #64748b; font-style: italic;">${escapeHtml(
                        meal.notes
                      )}</span>`
                    : ''
                }
              </div>
              <table style="width: 100%; border-collapse: collapse; font-size: 12.5px;">
                <tbody>${itemsRows}</tbody>
              </table>
            </div>`;
        })
        .join('');

      return `
        <div style="margin-top: 22px; page-break-inside: avoid;">
          <div style="display:flex; justify-content:space-between; align-items:baseline; border-bottom: 2px solid #0284c7; padding-bottom: 6px; margin-bottom: 12px;">
            <h2 style="margin:0; font-size: 16px; color: #0f172a;">${escapeHtml(day.label || 'Day')}</h2>
            <span style="font-size: 12px; color: #475569; font-weight: 600;">
              Total: ${Math.round(dayTotals.kcal)} kcal · P: ${Math.round(dayTotals.p)}g · C: ${Math.round(
        dayTotals.c
      )}g · F: ${Math.round(dayTotals.f)}g
            </span>
          </div>
          ${mealsHtml}
        </div>`;
    })
    .join('');

  const groceryHtml = Object.entries(groceryByCategory)
    .map(([category, itemsMap]) => {
      const lis = Object.entries(itemsMap)
        .map(
          ([name, totalGrams]) =>
            `<li style="margin-bottom: 4px;"><strong>${escapeHtml(name)}</strong>: ${Math.round(
              totalGrams
            )}g</li>`
        )
        .join('');
      return `
        <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 10px 14px;">
          <h4 style="margin: 0 0 6px 0; font-size: 12px; text-transform: uppercase; color: #0284c7;">
            ${escapeHtml(category)}
          </h4>
          <ul style="margin: 0; padding-left: 16px; font-size: 12px; color: #334155;">
            ${lis}
          </ul>
        </div>`;
    })
    .join('');

  const html = `<!DOCTYPE html>
<html lang="${escapeHtml(lang)}">
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(plan.title || 'Meal Plan')} – TODOenBALANCE</title>
  <style>
    @page { margin: 16mm; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      color: #1e293b;
      line-height: 1.45;
      margin: 0;
      padding: 0;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      border-bottom: 3px solid #10b981;
      padding-bottom: 14px;
      margin-bottom: 18px;
    }
    .brand {
      font-size: 22px;
      font-weight: 800;
      color: #0f172a;
      letter-spacing: -0.02em;
    }
    .brand span { color: #10b981; }
    .targets-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 10px;
      margin-bottom: 18px;
    }
    .target-card {
      background: #f0fdf4;
      border: 1px solid #bbf7d0;
      border-radius: 10px;
      padding: 10px;
      text-align: center;
    }
    .target-card .val { font-size: 16px; font-weight: 800; color: #065f46; }
    .target-card .lbl { font-size: 11px; color: #047857; text-transform: uppercase; }
    .grocery-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      margin-top: 10px;
    }
    @media print {
      .no-print { display: none !important; }
    }
  </style>
</head>
<body>
  <div class="no-print" style="background:#0f172a; color:#fff; padding:10px 20px; display:flex; justify-content:space-between; align-items:center;">
    <span style="font-size:13px;">TODOenBALANCE · Print / Save as PDF</span>
    <button onclick="window.print()" style="background:#10b981; color:#fff; border:none; padding:8px 16px; border-radius:8px; font-weight:700; cursor:pointer;">
      🖨️ Print / Save PDF
    </button>
  </div>

  <div style="max-width: 820px; margin: 20px auto; padding: 0 12px;">
    <div class="header">
      <div>
        <div class="brand">TODOen<span>BALANCE</span></div>
        <div style="font-size: 12px; color: #64748b; margin-top: 2px;">${escapeHtml(dict.subtitle)}</div>
        <h1 style="margin: 10px 0 0 0; font-size: 20px; color: #0f172a;">${escapeHtml(plan.title)}</h1>
      </div>
      <div style="text-align: right; font-size: 12px; color: #475569;">
        ${
          patient?.full_name
            ? `<div><strong>${escapeHtml(dict.patient)}:</strong> ${escapeHtml(patient.full_name)}</div>`
            : ''
        }
        <div><strong>${escapeHtml(dict.date)}:</strong> ${new Date().toLocaleDateString()}</div>
      </div>
    </div>

    <div style="font-size: 12px; font-weight: 700; text-transform: uppercase; color: #475569; margin-bottom: 8px;">
      ${escapeHtml(dict.dailyTargets)}
    </div>
    <div class="targets-grid">
      <div class="target-card">
        <div class="val">${plan.target_kcal || 1800} kcal</div>
        <div class="lbl">${escapeHtml(dict.calories)}</div>
      </div>
      <div class="target-card">
        <div class="val">${macros.protein_g || 110} g</div>
        <div class="lbl">${escapeHtml(dict.protein)}</div>
      </div>
      <div class="target-card">
        <div class="val">${macros.carbs_g || 180} g</div>
        <div class="lbl">${escapeHtml(dict.carbs)}</div>
      </div>
      <div class="target-card">
        <div class="val">${macros.fat_g || 65} g</div>
        <div class="lbl">${escapeHtml(dict.fat)}</div>
      </div>
      <div class="target-card">
        <div class="val">${macros.fiber_g || 30} g</div>
        <div class="lbl">${escapeHtml(dict.fiber)}</div>
      </div>
    </div>

    ${
      plan.general_guidelines
        ? `<div style="background:#eff6ff; border:1px solid #bfdbfe; border-radius:12px; padding:12px 16px; margin-bottom:18px;">
            <div style="font-size:12px; font-weight:700; color:#1e40af; margin-bottom:4px;">${escapeHtml(
              dict.guidelines
            )}</div>
            <div style="font-size:12.5px; color:#1e3a8a; white-space:pre-line;">${escapeHtml(
              plan.general_guidelines
            )}</div>
          </div>`
        : ''
    }

    ${daysHtml}

    <div style="margin-top: 28px; page-break-inside: avoid;">
      <h3 style="margin: 0 0 8px 0; font-size: 15px; color: #0f172a; border-bottom: 2px solid #10b981; padding-bottom: 5px;">
        🛒 ${escapeHtml(dict.groceryList)}
      </h3>
      <div class="grocery-grid">
        ${groceryHtml}
      </div>
    </div>

    <div style="margin-top: 32px; padding-top: 12px; border-top: 1px solid #e2e8f0; text-align: center; font-size: 11px; color: #94a3b8;">
      ${escapeHtml(dict.footer)}
    </div>
  </div>
</body>
</html>`;

  const win = window.open('', '_blank');
  if (win) {
    win.document.open();
    win.document.write(html);
    win.document.close();
  }
};
